import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { useRestockManagement } from "@/hooks/useRestockManagement";

interface RestockDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedItem: any;
  refetch: () => void;
}

export const RestockDialog = ({
  open,
  onOpenChange,
  selectedItem,
  refetch,
}: RestockDialogProps) => {
  const {
    restockQuantity,
    setRestockQuantity,
    handleRestock,
    isQuantityValid,
  } = useRestockManagement({ selectedItem, refetch, onClose: () => onOpenChange(false) });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            Réapprovisionnement - {selectedItem?.data?.name}
          </DialogTitle>
          <DialogDescription>
            Ajoutez la quantité que vous souhaitez ajouter au stock.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <label
              htmlFor="quantity"
              className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              Quantité à ajouter
            </label>
            <Input
              id="quantity"
              type="number"
              value={restockQuantity}
              onChange={(e) => setRestockQuantity(e.target.value)}
              placeholder="Entrez la quantité"
              min="1"
            />
            <p className="text-sm text-muted-foreground">
              Stock actuel: {selectedItem?.quantity} {selectedItem?.data?.unit || 'unités'}
            </p>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Annuler
          </Button>
          <Button 
            onClick={handleRestock}
            disabled={!isQuantityValid}
          >
            Confirmer
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};